package com.essntl.features.paymentparameter.ui.addeditpaymentparameter

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.State
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel
import com.essntl.features.paymentparameter.domain.repository.PaymentParameterRepository
import com.essntl.toastmanager.ToastManager
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

class AddEditPaymentParameterViewModel(
    private val paymentParameterRepository: PaymentParameterRepository,
    private val toastManager: ToastManager,
    private val state: MutableStateFlow<AddEditPaymentParameterState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {
    fun onEvent(event: AddEditPaymentParameterEvent) {
        when (event) {
            is AddEditPaymentParameterEvent.GetPaymentParameter -> getPaymentParameter(event)
            is AddEditPaymentParameterEvent.UpdatePaymentParameterFields -> updatePaymentParameterFields(event)
            is AddEditPaymentParameterEvent.AddPaymentParameter -> addPaymentParameter()
            is AddEditPaymentParameterEvent.EditPaymentParameter -> editPaymentParameter()
            is AddEditPaymentParameterEvent.ClearState -> clearState()
        }
    }

    private var getPaymentParameterJob: Job? = null
    private fun getPaymentParameter(event: AddEditPaymentParameterEvent.GetPaymentParameter) {
        getPaymentParameterJob?.cancel()
        getPaymentParameterJob = getData(
            getData = { paymentParameterRepository.getById(event.id) },
            getState = { state.value.getPaymentParameter },
            setState = {
                state.value = state.value.copy(
                    getPaymentParameter = it,
                    isEditEnabled = false,
                )
            },
            onSuccess = { p ->
                state.value.paymentParameter.value = p
            },
        )
    }

    private fun updatePaymentParameterFields(event: AddEditPaymentParameterEvent.UpdatePaymentParameterFields) {
        state.value.paymentParameter.value = event.paymentParameter
        val newPaymentParameter =
            state.value.getPaymentParameter.data?.getChangedFields(state.value.paymentParameter.value) ?: return
        state.update {
            it.copy(isEditEnabled = !newPaymentParameter.isEmpty)
        }
    }

    private fun addPaymentParameter() =
        getData(
            getData = { paymentParameterRepository.insert(state.value.paymentParameter.value) },
            getState = { state.value.addEditPaymentParameter },
            setState = { state.value = state.value.copy(addEditPaymentParameter = it) },
            onSuccess = { p ->
                state.update {
                    it.copy(
                        getPaymentParameter = State.success(p),
                    )
                }

                state.value.paymentParameter.value = p

                toastManager.success(
                    description = "Payment Parameter created successfully",
                )
            },
        )

    private fun editPaymentParameter() =
        getData(
            getData = { paymentParameterRepository.update(state.value.paymentParameter.value) },
            getState = { state.value.addEditPaymentParameter },
            setState = { state.value = state.value.copy(addEditPaymentParameter = it) },
            onSuccess = { ta ->
                state.update {
                    it.copy(
                        getPaymentParameter = State.success(ta),
                    )
                }

                state.value.paymentParameter.value = ta

                toastManager.success(
                    description = "Payment Parameter updated successfully",
                )
            },
        )

    private fun clearState() {
        state.value = state.value.copy(
            getPaymentParameter = State(),
            addEditPaymentParameter = State(),
            isEditEnabled = false,
        )

        state.value.paymentParameter.value = PaymentParameterModel.empty.copy(
            method = PaymentParameterModel.Method.Add,
            type = PaymentParameterModel.Type.FlatFee,
        )
    }
}